import { z } from 'zod';
export const loginSchema = z.object({
    username: z.string().trim().min(3).max(64),
    password: z.string().min(8).max(200),
});
export const authUserSchema = z.object({
    id: z.string(),
    username: z.string(),
    slug: z.string(),
    displayName: z.string(),
});
//# sourceMappingURL=auth.schema.js.map